export enum PayinRequisitesKind {
  Qr = 'qr',
  PaymentLink = 'payment_link',
  Card = 'card',
  Phone = 'phone',
  AccountNumber = 'account_number',
  None = 'none',
}
